import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBmEy3J5bjBIURqpBX47_hwOu8tnY3VAu8",
  authDomain: "doodle-cart-app.firebaseapp.com",
  projectId: "doodle-cart-app",
  appId: "1:570907739716:web:5f7d91d46b9f95613e9e11",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
